export const aboutContent = {
  brandIntro: {
    headline: '关于香蕉视频',
    subheadline: '用创意点亮生活，让每一个精彩瞬间都被看见',
    description: '香蕉视频成立于2020年，是一家专注于创意短视频内容的生产与分发的互联网科技公司。我们致力于为全球用户打造一个充满活力、富有创意的短视频社区平台。',
    mission: '让每个人都能轻松创作、快乐分享，用短视频连接世界',
    vision: '成为全球最具影响力的创意短视频平台',
    values: ['用户至上', '创新驱动', '真诚分享', '多元包容', '社会责任'],
    founded: '2020年',
    headquarters: '北京市朝阳区创意产业园',
    employees: '5000+人',
  },
  milestones: [
    { year: '2020', event: '香蕉视频App正式上线，首月用户突破100万' },
    { year: '2021', event: '用户突破5000万，完成A轮融资，开启创作者激励计划' },
    { year: '2022', event: '日活用户突破1亿，上线直播功能，覆盖10个国家' },
    { year: '2023', event: '全球用户突破2亿，AI推荐系统全面升级，电商功能上线' },
    { year: '2024', event: '推出AR特效创作平台，创作者突破2000万，覆盖30+国家' },
  ],
  reputation: {
    headline: '平台口碑',
    subheadline: '来自用户与行业的真实评价',
    awards: [
      { title: '最佳创新应用奖', issuer: '中国互联网协会', year: '2023' },
      { title: '年度最受欢迎App', issuer: '应用商店年度评选', year: '2023' },
      { title: '最佳用户体验奖', issuer: 'UX设计大奖', year: '2024' },
      { title: '最具社会责任企业', issuer: '中国企业社会责任峰会', year: '2024' },
    ],
    userReviews: [
      {
        name: '小王同学',
        role: '忠实用户 · 3年',
        avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20with%20happy%20smile%2C%20casual%20outfit%2C%20bright%20natural%20lighting%2C%20clean%20background%2C%20friendly%20headshot&width=120&height=120&seq=review-01&orientation=squarish',
        content: '用了三年香蕉视频，从最初的刷视频到现在自己也成了创作者。这个平台真的改变了我对短视频的认知，不只是消磨时间，更是发现世界的一种方式。',
      },
      {
        name: '创意达人小李',
        role: '认证创作者 · 2年',
        avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20creative%20professional%20portrait%20with%20confident%20expression%2C%20artistic%20style%2C%20warm%20studio%20lighting%2C%20clean%20minimal%20background&width=120&height=120&seq=review-02&orientation=squarish',
        content: '作为一名全职创作者，香蕉视频给我的不仅是展示才华的舞台，更是实实在在的收入。创作激励计划让我可以专注于内容创作，追逐自己的梦想。',
      },
      {
        name: '张阿姨',
        role: '活跃用户 · 1年',
        avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20woman%20portrait%20with%20warm%20gentle%20smile%2C%20casual%20elegant%20style%2C%20soft%20natural%20lighting%2C%20clean%20background&width=120&height=120&seq=review-03&orientation=squarish',
        content: '女儿推荐我用的，一开始以为只是年轻人玩的，没想到里面有很多美食和养生内容，现在每天都要刷一刷，学到了不少新菜谱呢！',
      },
    ],
    stats: [
      { value: '4.9', label: 'App Store评分' },
      { value: '98%', label: '用户满意度' },
      { value: '2000万+', label: '好评数量' },
      { value: 'Top 1', label: '应用商店排行' },
    ],
  },
  contact: {
    headline: '联系我们',
    subheadline: '期待与你交流，一起创造更多精彩',
    address: '北京市朝阳区创意产业园A座18层',
    phone: '400-888-9999',
    email: 'contact@xiangjiaotv.com',
    wechat: 'xiangjiaotv_official',
    workHours: '周一至周五 9:00 - 18:00',
  },
};